import React from 'react';
import PropTypes from 'prop-types';
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import {
  IMPORT_DATA_STATUS,
  SCHEDULE_EXPORT_STATUS,
} from '../../config/const.config';
import Iconify from '../common/iconify.component';

const ListImportExportData = ({
  rows,
  loading,
  error,
  handleDownloadFile,
  fromImport,
  disabledDownload,
  downloadingFiles,
}) => (
  <TableContainer component={Paper} variant="outlined" square>
    <Table size="small" aria-label="a dense table">
      <TableBody>
        {!loading && !error && rows.length > 0 && (
          <>
            {rows.map((rs) => (
              <TableRow key={`import-export-${rs.id}`}>
                <TableCell width="70%">{rs.downloadFileName}</TableCell>
                <TableCell width="20%">
                  {fromImport
                    ? IMPORT_DATA_STATUS[rs.status].label
                    : SCHEDULE_EXPORT_STATUS[rs.status]}
                </TableCell>
                <TableCell width="10%" align="right">
                  {(
                    fromImport
                      ? rs.status === IMPORT_DATA_STATUS.FINISHED.value
                      : rs.status === SCHEDULE_EXPORT_STATUS.ACTIVE
                  ) ? (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleDownloadFile(rs)}
                      disabled={
                        disabledDownload || downloadingFiles?.includes(rs.id)
                      }
                      sx={{ minWidth: 0 }}
                    >
                      {downloadingFiles?.includes(rs.id) ? (
                        <Iconify icon="eos-icons:loading" />
                      ) : (
                        <Iconify icon="ic:baseline-download" />
                      )}
                    </Button>
                  ) : (
                    ''
                  )}
                </TableCell>
              </TableRow>
            ))}
          </>
        )}

        {!loading && !error && rows.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={3}>
              <Typography variant="body2" sx={{ my: 10 }}>
                No data found
              </Typography>
            </TableCell>
          </TableRow>
        )}

        {!loading && error && rows.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={3}>
              <Typography variant="body2" sx={{ my: 10 }}>
                Something went wrong. Please try again.
              </Typography>
            </TableCell>
          </TableRow>
        )}

        {loading && (
          <TableRow>
            <TableCell align="center" colSpan={3}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 200,
                  height: '100%',
                }}
              >
                <CircularProgress disableShrink />
              </Box>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

ListImportExportData.propTypes = {
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  handleDownloadFile: PropTypes.func.isRequired,
  fromImport: PropTypes.bool.isRequired,
  disabledDownload: PropTypes.bool.isRequired,
  downloadingFiles: PropTypes.array.isRequired,
};

export default ListImportExportData;
